import React from 'react'

import { useAppSelector } from 'reduxTyped'
import { mapFields } from 'common/fields/api/adapter'
import { FieldGroupId } from 'common/fields/entities/enums'
import FieldPicker, { FieldPickerProps } from 'common/fields/linking/components/FieldPicker'
import {
  FieldClearEvent,
  FieldSelectEvent,
} from 'common/fields/linking/components/interfaces/fieldEvents'
import { botFieldsSelector, userFieldsSelector } from 'common/mapping/store'

type AllowedGroup = FieldGroupId.BOT | FieldGroupId.USER

type TargetPageGlobalFieldsPickerProps = {
  group: AllowedGroup
  onChange: (event: FieldSelectEvent | FieldClearEvent) => void
} & Omit<FieldPickerProps, 'fields' | 'onSelect' | 'onClear'>

const TargetPageGlobalFieldsPicker: React.ForwardRefRenderFunction<
  HTMLInputElement,
  TargetPageGlobalFieldsPickerProps
> = ({ group, onChange, ...props }, ref) => {
  const botFields = useAppSelector(botFieldsSelector)
  const userFields = useAppSelector(userFieldsSelector)

  const rawFields = group === FieldGroupId.BOT ? botFields : userFields

  const fields = mapFields(
    group,
    rawFields.map((rawField: { field_id?: number; id?: number }) => ({
      ...rawField,
      name: rawField.field_id || rawField.id,
    })),
  )

  return <FieldPicker ref={ref} fields={fields} onSelect={onChange} onClear={onChange} {...props} />
}

export default React.forwardRef(TargetPageGlobalFieldsPicker)
